import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import BaseGrid from "Components/Fragment/BaseGrid";
import { CircularProgress } from "Components/Base/Feedback/CircularProgress";
import LuvitComponent from "LuvitComponent";
import format from "lib/format";
import Card from "./card";
import CourseDetails from "./courseDetails";
import Measure from "react-measure";
import Filter from "./Filter";
import { MyCoursesCardStore } from "./Store";
import { observer } from "mobx-react";
import UserStore from "stores/user";
import HeaderSelection from "../header/coworker";
import UserInfoHeading from "../User/container";
import ProgramCards from "./Programs/ProgramCards";
import Program from "domains/programs/components/Program";
import { ToolbarButton } from "lib/components/Button";
import { DISPLAY_MODE_FULL, PROGRESS_ALL } from "./constants";
import SettingStore from "stores/settings";
import { Accordion } from "Components/Base/Surfaces/Accordion";
import {
  VIEWPORT_SMALL,
  VIEWPORT_X_SMALL,
  VIEWPORT_MEDIUM,
  VIEWPORT_LARGE,
} from "./constants";
import theme from "../../themes/theme";
import Courses from "./Courses";

const calculateProgress = (completed, steps) => {
  return Math.round((completed / steps) * 100) || 0;
};

@observer
export default class MyCoursesCardView extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
    this.refresh = this.refresh.bind(this);
    this.resolveMediaClass = this.resolveMediaClass.bind(this);
    this.openDetails = this.openDetails.bind(this);
    this.toggleProgramDetails = this.toggleProgramDetails.bind(this);
    this.closeDetails = this.closeDetails.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.doRender = this.doRender.bind(this);
  }

  async componentWillMount() {
    this.setState({ ready: false, dimensions: { width: -1, height: -1 } });
    let store = new MyCoursesCardStore();
    await store.refresh(this.props.personalId);

    const noOfCoursesInSimpleMode = SettingStore.getSettingValue(
      "noofcoursesinmycoursespanel",
    );
    const isBt = SettingStore.isBt();

    this.setState({
      ready: true,
      store,
      noOfCoursesInSimpleMode,
      noOfCourses: store.courses.length,
      programDetails: null,
      isBt,
    });

    if (isBt) {
      store.setFilter(PROGRESS_ALL);
    }
  }

  async refresh() {
    let store = new MyCoursesCardStore();
    await store.refresh(this.props.personalId);
    this.setState({ store });
  }

  resolveMediaClass() {
    //Deal with responsiveness, calculate breakpoints depending on how many category levels and tags
    let store = this.state.store;
    let noOfCategoryLevels = 0;
    let categoryId = this.state.categoryId;
    for (let cat = categoryId; cat; cat = store.categories[cat].parentId) {
      noOfCategoryLevels++;
    }

    let noOfTags = this.state.store.tags.length;
    let noOfFilters = noOfTags + noOfCategoryLevels;

    let neededWidthMedium = noOfFilters * 40 + 800;

    if (neededWidthMedium < 800) {
    }

    let neededWidthSmall = noOfFilters * 27 + 600;

    const { width, height } = this.state.dimensions;

    return width < neededWidthMedium && width > neededWidthSmall
      ? VIEWPORT_MEDIUM
      : width < neededWidthSmall && width > 520
        ? VIEWPORT_SMALL
        : width < 520
          ? VIEWPORT_X_SMALL
          : VIEWPORT_LARGE;
  }

  openDetails(course) {
    this.setState({ courseDetails: course });
  }

  toggleProgramDetails(activityId) {
    this.setState({
      programDetails: !this.state.programDetails,
      programActivityId: activityId,
    });
  }

  closeDetails() {
    this.setState({ courseDetails: null });
  }

  renderHeader() {
    const { isBt } = this.state;
    const isManagerOrAdmin = this.props.managerView || UserStore.user.fromAdmin;
    if (isManagerOrAdmin) {
      return (
        <>
          <HeaderSelection href="#/tm/coworker/mycourses" />
          <UserInfoHeading
            personalId={this.props.personalId}
            pageTitle={
              isBt ? this.l("programsandprogress") : this.l("mylearning")
            }
          />
        </>
      );
    }
    return null;
  }

  doRender() {
    if (!this.state.ready) return <div />;
    let store = this.state.store;
    let filteredCourses = store.filteredCourses.active;
    let filteredPrograms = store.filteredPrograms.active;
    const displayPrograms = filteredPrograms && filteredPrograms.length > 0;
    const { mode } = this.props;
    const { programDetails, courseDetails, isBt } = this.state;
    const numberOfCompletedSteps =
      store.courses.filter((course) => course.completed === true).length +
      store.programs.filter((program) => program.completed === true).length;
    const numberOfSteps = store.courses.length + store.programs.length;
    const totalPercentCompleted = calculateProgress(
      numberOfCompletedSteps,
      numberOfSteps,
    );

    if (isBt) {
      filteredPrograms = filteredPrograms.filter((program) => {
        return program.bt;
      });
    }

    let mediaClass = this.resolveMediaClass();

    if (mode != DISPLAY_MODE_FULL) {
      if (filteredCourses.length > this.state.noOfCoursesInSimpleMode) {
        filteredCourses = filteredCourses.slice(
          0,
          this.state.noOfCoursesInSimpleMode,
        );
      }
      if (
        filteredPrograms &&
        filteredPrograms.length > this.state.noOfCoursesInSimpleMode
      ) {
        filteredPrograms = filteredPrograms.slice(
          0,
          this.state.noOfCoursesInSimpleMode,
        );
      }
    }
    const isManagerOrAdmin = this.props.managerView || UserStore.user.fromAdmin;

    return (
      <ThemeProvider theme={theme}>
        <div>
          {isManagerOrAdmin && this.renderHeader()}

          {!programDetails && (
            <Measure
              onMeasure={(dimensions) => {
                this.setState({ dimensions });
              }}
            >
              <div
                className="bgColor-6 padding-10"
                style={{ maxWidth: "1050px" }}
              >
                {mode === DISPLAY_MODE_FULL && !isManagerOrAdmin && (
                  <div className="flex flex-space-b">
                    <h1 className="page-header">
                      {isBt
                        ? this.l("programsandprogress")
                        : this.l("mylearning")}
                    </h1>
                  </div>
                )}
                <div
                  className={
                    mode === DISPLAY_MODE_FULL ? "hidden" : "panel-header"
                  }
                >
                  <div className="icon-courses" aria-hidden="true" />
                  <h2 className="panel-heading">
                    <span className="paneltitle">
                      {isBt
                        ? this.l("programsandprogress")
                        : this.l("mylearning")}
                    </span>
                  </h2>
                </div>
                {this.state.noOfCourses > 0 && !isBt && (
                  <Filter
                    mediaClass={mediaClass}
                    mode={mode}
                    store={store}
                    totalPercentCompleted={totalPercentCompleted}
                  />
                )}
                {store.searching ? (
                  <CircularProgress />
                ) : (
                  <BaseGrid
                    childWidth="auto"
                    justifyContent={"space-between"}
                    direction="column"
                  >
                    {displayPrograms && (
                      <Accordion
                        defaultExpanded
                        slotProps={{
                          transition: {
                            unmountOnExit: true,
                            timeout: 0,
                          },
                        }}
                        disableGutters
                        TransitionProps={{ timeout: 0 }}
                        summaryText={this.l("programs")}
                        detailsText={
                          <div
                            className={
                              "cardview-courselist flex flex-wrap " + mediaClass
                            }
                            id="programMyLearningList"
                          >
                            <ProgramCards
                              programs={filteredPrograms}
                              context={this.l}
                              onClick={this.toggleProgramDetails}
                              personalId={this.props.personalId}
                              managerView={isManagerOrAdmin}
                            />
                          </div>
                        }
                      />
                    )}

                    {!this.state.isBt && (
                      <Accordion
                        defaultExpanded
                        slotProps={{
                          transition: {
                            unmountOnExit: true,
                            timeout: 0,
                          },
                        }}
                        disableGutters
                        TransitionProps={{ timeout: 0 }}
                        summaryText={this.l("courses")}
                        detailsText={
                          <div
                            className={`cardview-courselist flex flex-wrap ${mediaClass}`}
                            id="learningActivitiesMyLearningList"
                          >
                            {filteredCourses.map((c) => (
                              <Card
                                key={
                                  c.courseType == 2
                                    ? c.courseId + "_" + c.activityId
                                    : c.courseId
                                }
                                store={store}
                                course={c}
                                mode={this.props.mode}
                                personalId={this.props.personalId}
                                openDetails={this.openDetails}
                                closeDetails={this.closeDetails}
                                isManagerOrAdmin={isManagerOrAdmin}
                                refresh={this.refresh}
                              />
                            ))}
                          </div>
                        }
                      />
                    )}
                  </BaseGrid>
                )}
                {this.state.noOfCourses == 0 && !this.state.isBt && (
                  <div className="tag-warning">
                    {this.l("nocourseregistrations")}
                  </div>
                )}

                {this.state.noOfCourses > 0 && !this.state.isBt && (
                  <div
                    className={
                      mode === DISPLAY_MODE_FULL
                        ? "hidden"
                        : "flex flex-end cardview-showall align-c"
                    }
                  >
                    <a href={format.url("/#/tm/coworker/mycourses")}>
                      {this.l("showall")}
                    </a>
                    <span className="icon-doublearrows"></span>
                  </div>
                )}

                {courseDetails && (
                  <CourseDetails
                    initiallyOpen
                    title={courseDetails.title}
                    dialogStyles={{ minWidth: "450px" }}
                    course={courseDetails}
                    closeDetails={this.closeDetails}
                    personalId={this.props.personalId}
                    isManagerOrAdmin={isManagerOrAdmin}
                  ></CourseDetails>
                )}
              </div>
            </Measure>
          )}

          {programDetails && (
            <div className="padding-10 bgColor-6 animated fadeInDown">
              <div className="toolbar flex align-c">
                <ToolbarButton
                  icon="icon-back"
                  label={this.l("back")}
                  mobileDisplay={true}
                  onClick={() => this.toggleProgramDetails()}
                  id={"buttonBack"}
                />
                &nbsp;
                <span>{this.l("back")}</span>
              </div>
              <Accordion
                defaultExpanded
                detailsText={
                  <Program
                    {...this.props}
                    activityId={this.state.programActivityId}
                    managerView={isManagerOrAdmin}
                    personalId={this.props.personalId}
                  />
                }
                boxShadow
              />
            </div>
          )}
        </div>
      </ThemeProvider>
    );
  }
}
